import { render, staticRenderFns } from "./CarSlideComponent.vue?vue&type=template&id=bc8982fa&scoped=true"
import script from "./CarSlideComponent.vue?vue&type=script&lang=js"
export * from "./CarSlideComponent.vue?vue&type=script&lang=js"
import style0 from "./CarSlideComponent.vue?vue&type=style&index=0&id=bc8982fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8982fa",
  null
  
)

export default component.exports